import { imbalancesApi } from "../../../../../../api/dashboard/imbalancesApi";
import { validateInput } from "../../helpers/tools/validateInput";
import { RotationsRenderClass } from "./rotationsRenderClass";
import { ZoneRenderClass } from "./zoneRenderClass";

export class ImbalancesOperationClass {
  constructor(tvChart, pair, imbalanceValue, setDataLoading, setError) {
    this.thisClassName = 'ImbalancesOperationClass'
    const additionalErrorMessage = 'constructor()'
    validateInput(tvChart, 'tvChart', this.thisClassName, additionalErrorMessage);
    validateInput(pair, 'pair', this.thisClassName, additionalErrorMessage);
    validateInput(imbalanceValue, 'imbalanceValue', this.thisClassName, additionalErrorMessage);

    this.tvChart = tvChart;
    this.pair = pair.replace("/", "");
    this.imbalanceValue = imbalanceValue;
    this.setDataLoading = setDataLoading;
    this.setError = setError
  }

  plotZones = async () => {
    this.setDataLoading(prev => ({ ...prev, zones: true }));
    const zoneRender = new ZoneRenderClass(
        this.tvChart,
        this.pair,
        this.imbalanceValue
    );
    const pair = this.pair.toUpperCase();

    if (this.tvChart.current) {
        let zonesList = await imbalancesApi.getZonesAndRotation('imbalance_zones', pair);
        try {
          if(zonesList?.data) {
            zoneRender.action(zonesList?.data);
            this.setDataLoading(prev => ({ ...prev, zones: false }));
          } else if(zonesList?.error) {
            console.error('plotZones Error => ', zonesList?.error?.message, 'data => ', zonesList?.data);
            this.setError(true);
            this.setDataLoading(prev => ({ ...prev, zones: false }));
          }
        } catch (error) {
          if(zonesList?.error) {
            console.error('catch plotZones Error => ', zonesList?.error?.message, 'data => ', zonesList?.data);
            this.setError(true);
          }
          this.setDataLoading(prev => ({ ...prev, zones: false }));
        }
    }
  };

  plotRotations = async () => {
    this.setDataLoading(prev => ({ ...prev, rotations: true }));
    const rotationsRender = new RotationsRenderClass(
        this.tvChart,
        this.pair,
        this.imbalanceValue
    );
    const pair = this.pair.toUpperCase();

    if (this.tvChart.current) {
      let rotationsList = await imbalancesApi.getZonesAndRotation('rotations', pair);
      try {
        if(rotationsList?.data) {
          rotationsRender.action(rotationsList?.data);
          this.setDataLoading(prev => ({ ...prev, rotations: false }));
        } else if(rotationsList?.error) {
          console.error('plotRotations Error => ', rotationsList?.error?.message, 'data => ', rotationsList?.data);
          this.setError(true);
          this.setDataLoading(prev => ({ ...prev, rotations: false }));
        }
      } catch (error) {
        if(rotationsList?.error) {
          console.error('catch plotRotations Error => ', rotationsList?.error?.message, 'data => ', rotationsList?.data);
          this.setError(true);
        }
        this.setDataLoading(prev => ({ ...prev, rotations: false }));
      }
    }
  };

  removeAllWidget = () => {
    if (this.tvChart.current && this.tvChart.current.activeChart()) {
      let allShape = this.tvChart.current.activeChart().getAllShapes();
      allShape.forEach((shape) => {
        this.tvChart.current.activeChart().removeEntity(shape.id);
      });
    }
  };
}
